export default __webpack_public_path__ + "locales/tr/EmptyTrashDialog.json?hash=7d2ee31fa6f18b1da4a76ed78b7b621a";